import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const size = {
  small: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 5.33334L6.5 10.6667L4 8.24243"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  default: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 8L9.75 16L6 12.3636"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  large: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24 10.6667L13 21.3333L8 16.4848"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

function CheckIcon(props: Omit<SvgIconProps, "fontSize"> & { fontSize?: "large" | "small" }) {
  const item = size[props.fontSize || "default"];

  return (
    <SvgIcon {...props} fontSize={props.fontSize}>
      {item}
    </SvgIcon>
  );
}
export default CheckIcon;
